import React, { useEffect } from "react";

interface DataTable {
  [key: string]: number[];
}

interface KpiTableComponentProps {
  dataTable: DataTable;
  dataTableII: DataTable;
  headers?: string[];
  headersVertical?: string[];
  rowColors?: string[];
  rowColorsData?: string[];
}

const KpiTableComponent: React.FC<KpiTableComponentProps> = ({
  dataTable,
  dataTableII,
  headers = [""],
  headersVertical = [""],
  rowColors = ["bg-gray-300"],
  rowColorsData = ["bg-gray-300"],
}) => {
  const maxLength = Math.max(
    ...Object.values(dataTable).map((arr) => arr.length)
  );

  const totalValidation = Object.keys(dataTable).map((key) => {
    return key > "" ? 1 : 0;
  });

  useEffect(() => {
    console.log(dataTable);
  }, [dataTable]);

  return (
    <div className="kpi grid grid-cols-3">

      <div className="mt-20">
        <div>
          <table className="table border-separate w-full text-left">
            <thead>
              <tr>
                {headers.length === 0 ? (
                  <th className="text-primary-500 text-lg text-center pb-10">
                    KPI
                  </th>
                ) : (
                  headers.map((head, index) => (
                    <th
                      key={index}
                      className={`text-primary-500 text-lg text-center ${
                        totalValidation[0] == 1 ? "pb-11" : "pb-4"
                      }`}
                    >
                      {head}
                    </th>
                  ))
                )}
              </tr>
            </thead>
            <tbody className="">
              {headersVertical.map((head, index) => (
                <tr
                  key={index}
                  className={`border-4 border-white h-12 w-full ${
                    rowColors[index] || "bg-gray-300"
                  }`}
                >
                  <td className="whitespace-nowrap overflow-hidden w-full pl-4 pr-5 text-ellipsis">
                    {head}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-12 ml-8 w-full">
        <div className="text-primary-500 font-medium text-lg pb-3 text-center align-middle whitespace-nowrap overflow-hidden">
          <p>Manual</p>
        </div>
        <div className="overflow-x-scroll w-11/12 pr-8">
          <table className="table border-separate [border-spacing:0px_3px] w-full">
            <thead>
              <tr className="">
                {Object.keys(dataTable).map((key) => {
                  return (
                    <th
                      key={key}
                      className="text-primary-500 text-sm pb-3 text-center align-middle whitespace-nowrap overflow-hidden px-3"
                    >
                      {key}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody id="data" className="">
              {Array.from({ length: maxLength }).map((_, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={`border-1 border-white h-12 w-full ${
                    rowColorsData[rowIndex] || "bg-gray-300"
                  }`}
                >
                  {Object.keys(dataTable).map((key) => (
                    <td
                      key={key}
                      className="whitespace-nowrap overflow-hidden text-center"
                    >
                      {dataTable[key] && dataTable[key][rowIndex] !== undefined
                        ? dataTable[key][rowIndex]
                        : ""}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-12 ml-8 w-full">
        <div className="text-primary-500 font-medium text-lg pb-3 text-center align-middle whitespace-nowrap overflow-hidden px-3">
          <p>Automatizado</p>
        </div>
        <div className="overflow-x-scroll w-11/12">
          <table className="table border-separate [border-spacing:0px_3px] w-full">
            <thead>
              <tr className="">
                {Object.keys(dataTableII).map((key) => {
                  return (
                    <th
                      key={key}
                      className="text-primary-500 text-sm pb-3 text-center align-middle whitespace-nowrap overflow-hidden px-3"
                    >
                      {key}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody id="data" className="">
              {Array.from({ length: maxLength }).map((_, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={`border-1 border-white h-12 w-full ${
                    rowColorsData[rowIndex] || "bg-gray-300"
                  }`}
                >
                  {Object.keys(dataTableII).map((key) => (
                    <td
                      key={key}
                      className="whitespace-nowrap overflow-hidden text-center"
                    >
                      {dataTableII[key] && dataTableII[key][rowIndex] !== undefined
                        ? dataTableII[key][rowIndex]
                        : ""}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
    </div>
  );
};

export default KpiTableComponent;